// 3層構造の中間層: FieldWrapper + FileUpload プリミティブ
import React, { ComponentProps } from 'react';
import { FieldWrapper } from '../FieldWrapper';
import { FileUpload } from '../FormItems/FileUpload';

type FieldWrapperProps = ComponentProps<typeof FieldWrapper>;
type FileUploadProps = ComponentProps<typeof FileUpload>;

type Props = {
  fileUpload: FileUploadProps;
  fieldWrapperProps: Omit<FieldWrapperProps, 'children'>;
};

export const FileUploadField: React.FC<Props> = ({
  fileUpload,
  fieldWrapperProps: { htmlFor, labelType, labelText, beforeMessage, errorMessages },
}) => (
  <FieldWrapper
    htmlFor={htmlFor}
    labelType={labelType}
    labelText={labelText}
    beforeMessage={beforeMessage}
    errorMessages={errorMessages}
  >
    <FileUpload {...fileUpload} />
  </FieldWrapper>
);
